<nav>
  <div class="nav-box">
    <ul class="nav-container">
      @for (item of bottomNavigationItems; track item; let i = $index) {
        <li (click)="setActiveItem(item)" [class.active]="item.active" class="nav__item">
          <a class="nav__item-link">
            <div class="nav__item-icon">
              @if (item.active) {
                <app-icon [iconName]="item.icon" color="var(--orange)" size="24px"></app-icon>
              }
              @if (!item.active) {
                <app-icon [iconName]="item.icon" color="var(--slate-gray)" size="24px"></app-icon>
              }
            </div>
            <span [ngStyle]="{ color: item.active ? 'var(--orange)' : 'var(--text-color-medium)' }" class="nav__item-text">{{ item.title | translate }}</span>
          </a>
        </li>
      }
    </ul>
  </div>
</nav>
